exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#finalreparto h3 {\r\n  font-size: 1.5em;\r\n  margin-top: 1vh;\r\n  width: 85%;\r\n  margin-left: 7.5%;\r\n}\r\n#finalreparto h1 {\r\n  margin-top: 2vh;\r\n}\r\n#finalreparto button {\r\n  width: 85%;\r\n  height: 62px;\r\n  color: white;\r\n  position: fixed;\r\n  left: 7.5%;\r\n  bottom: 3%;\r\n}\r\n#finalreparto {\r\n  height: 100vh;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/uriel/Documents/newspaperReporteador/src/app/components/final-reparto/final-reparto.component.css
// module id = ../../../../../src/app/components/final-reparto/final-reparto.component.css
// module chunks = main